import { AfterViewInit, Component, DoCheck, Input, KeyValueDiffer, KeyValueDiffers, OnInit } from '@angular/core';
import { ApiService, ChatMessage, LoggerService } from 'angular-lib/index';

@Component({
    selector: 'ez-chat-message',
    styles: [require('./message.component.less')],
    template: require('./message.component.html'),
})
export class ChatMessageComponent implements AfterViewInit, DoCheck, OnInit {
    @Input() public message: ChatMessage;
    private differ: KeyValueDiffer<any, any>;

    constructor(
        private apiService: ApiService,
        private differs: KeyValueDiffers
    ) {}

    public ngAfterViewInit(): void {
        if (this.message.needReadsUpdate() && this.message.id > 0) {
            // this.setMessageRead();
        }
    }

    public ngOnInit() {
        this.differ = this.differs.find(this.message).create();
    }

    public ngDoCheck() {
        let changes = this.differ.diff(this.message);
        if (changes) {
            // check if message id change
            changes.forEachChangedItem(change => {
                if (change.key === 'id' && change.currentValue > 0) {
                    LoggerService.info('MESSAGE ID CHANGED');
                    this.setMessageRead();
                }
            });
        }
    }

    public setMessageRead() {
        this.apiService.post('/ws/chat/setMessageRead', JSON.stringify({
            messages: [this.message.idForUpdate()]
        })).first()
            .subscribe();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/chat/childs/message/message.component.ts